import { render } from "./FormularioTurma.vue?vue&type=template&id=711ec827&scoped=true"
import script from "./FormularioTurma.vue?vue&type=script&lang=js"
export * from "./FormularioTurma.vue?vue&type=script&lang=js"

import "./FormularioTurma.vue?vue&type=style&index=0&id=711ec827&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711ec827"]])

export default __exports__